/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { RefObject, useEffect } from 'react'
import { Field, Form, Formik, FormikProps } from 'formik'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Form as NXUIForm } from '@nexigendigital/nxui'
import { useChangePasswordMutation } from 'api/service'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    id: number,
    form: RefObject<FormikProps<{ password: string }>>,
    close: () => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function PasswordForm({ id, form, close }: Props) {
    const [changePassword, { isLoading, isSuccess, isError }] = useChangePasswordMutation()

    /**********************************************************************************************************
     *   SIDE EFFECTS
     **********************************************************************************************************/
    useEffect(() => {
        if ((isSuccess || isError) && form.current) {
            form.current.setSubmitting(false)
            form.current.resetForm()
            close()
        }
    }, [form, isSuccess, isError])

    return (
        <Formik
            innerRef={form}
            initialValues={{
                password: ''
            }}
            onSubmit={({ password }) => {
                changePassword({ id, password })
            }}
        >
            {() => (
                <Form id={'changePasswordForm'}>
                    <Field
                        label={'New Password'}
                        name={'password'}
                        disabled={isLoading}
                        autoComplete={'new-password'}
                        component={NXUIForm.InputField}
                    />
                </Form>
            )}
        </Formik>
    )
}
